<template>
  <b-button
    class="wider-save"
    @click="initial ? act() : startTimer()"
    size="is-large"
    type="is-success"
    :disabled="!$attrs.valid || saving || !$attrs.changed"
    :loading="saving"
  >
    <div class="children-overlap">
      <span>{{
        initial ? "Click to confirm" : saving ? "Saving..." : "Save Changes"
      }}</span>
      <span class="hidden">Click to confirm</span>
    </div></b-button
  >
</template>

<script>
import { bus } from "@/components/spaces/bus.js";

export default {
  props: ["saving"],
  data() {
    return {
      initial: false,
      existingTimeout: undefined,
    };
  },
  methods: {
    act() {
      this.initial = false;
      bus.$emit("saving-event");
    },
    startTimer() {
      this.initial = true;
      this.existingTimeout = setTimeout(() => {
        this.initial = false;
      }, 5000);
    },
  },
  watch: {
    initial(newValue) {
      if (!newValue) clearTimeout(this.existingTimeout);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/bulma_overrides.scss";
</style>
